import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
const WindowsIcon = React.memo((props) => {
    return (_jsx(SvgIcon, { ...props, children: _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: _jsx("path", { fill: "white", d: "M3,12V6.75L9,5.43V11.91L3,12M20,3V11.75L10,11.9V5.21L20,3M3,13L9,13.09V19.9L3,18.75V13M20,13.25V22L10,20.09V13.1L20,13.25Z" }) }) }));
});
export { WindowsIcon };
//# sourceMappingURL=WindowsIcon.js.map